export default __webpack_public_path__ + "img/MultipleBuildings.104504a1.svg";